"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EyeIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var themes_1 = require("../../themes");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, _c = _a.stroke, stroke = _c === void 0 ? 'black' : _c, _d = _a.opacity, opacity = _d === void 0 ? 1 : _d, size = _a.size, rest = __rest(_a, ["fill", "stroke", "opacity", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 26 24" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M1.65265 13.0189C1.23518 12.4035 1.23517 11.5965 1.65265 10.9811C4.58298 6.66111 8.58616 4 13 4C17.4138 4 21.417 6.66111 24.3474 10.9811C24.7648 11.5965 24.7648 12.4035 24.3474 13.0189C21.417 17.3389 17.4138 20 13 20C8.58616 20 4.58298 17.3389 1.65265 13.0189Z", stroke: stroke, strokeWidth: "1", opacity: opacity, fill: fill }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "13", cy: "12", r: "4", stroke: stroke, strokeWidth: "1", opacity: opacity, fill: fill ? themes_1.THEME.colors.basic.White100 : 'transparent' }, void 0)] }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, _c = _a.stroke, stroke = _c === void 0 ? 'black' : _c, _d = _a.opacity, opacity = _d === void 0 ? 1 : _d, size = _a.size, rest = __rest(_a, ["fill", "stroke", "opacity", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 34 32" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M1.72329 17.0687C1.26853 16.4282 1.26853 15.5718 1.72329 14.9313C5.64298 9.41068 11.0408 6 17 6C22.9592 6 28.357 9.41068 32.2767 14.9313C32.7315 15.5718 32.7315 16.4282 32.2767 17.0687C28.357 22.5893 22.9592 26 17 26C11.0408 26 5.64298 22.5893 1.72329 17.0687Z", stroke: stroke, strokeWidth: "1.5", opacity: opacity, fill: fill }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "17", cy: "16", r: "5.25", stroke: stroke, strokeWidth: "1.5", fill: fill ? themes_1.THEME.colors.basic.White100 : 'transparent' }, void 0)] }), void 0));
};
var EyeIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.EyeIcon = EyeIcon;
//# sourceMappingURL=EyeIcon.js.map